// extracted by mini-css-extract-plugin
export default {"uploadImageContainer":"UploadImage_uploadImageContainer__wNnx4"};